import { Component, Input, OnInit,EventEmitter, Output, ViewChild } from '@angular/core';
import { StoryService } from 'src/app/services/story.service';
import { SwiperComponent } from 'swiper/angular';
import SwiperCore, { SwiperOptions, Virtual,Pagination,EffectCards  } from 'swiper';
import { ModalController } from '@ionic/angular';
import { AssetlinksService } from 'src/app/services/assetlinks.service';
import { ForSaleCoupon, IndefiniteCoupon, Shop, Story } from 'src/app/models/interfaces';
import { Browser } from '@capacitor/browser';
import { PaystackOptions } from 'src/app/modules/paystack/models/paystack-options';
import { CloudfunctriggersService, Response, TransActionRef } from 'src/app/services/cloudfunctriggers.service';
import { AuthService } from 'src/app/services/auth.service';
import { LoadingService } from 'src/app/services/loading.service';
// install Swiper modules
SwiperCore.use([Virtual,Pagination]);

export interface CouponPaymentEvent{
  coupon:ForSaleCoupon,
  response:Response
  ref:TransActionRef
}

@Component({
  selector: 'app-coupon-listing-viewer',
  templateUrl: './coupon-listing-viewer.component.html',
  styleUrls: ['./coupon-listing-viewer.component.scss'],
})
export class CouponListingViewerComponent  implements OnInit {
  @Input() shop:Shop;
  @Input() coupons:Array<ForSaleCoupon>;
  @Input() userLocation:{lat:number,lng:number,geohash:string}|null;
  @Output() paymentResultSuccess: EventEmitter<CouponPaymentEvent> = new EventEmitter<CouponPaymentEvent>();
  @Output() paymentResultFailure: EventEmitter<CouponPaymentEvent> = new EventEmitter<CouponPaymentEvent>();
  paystackOptions:PaystackOptions;
  buyButtonText='Buy'
  @ViewChild('swiper', { static: false }) swiper?: SwiperComponent;
  linkClickThinking=false
  constructor(
    public assetLinksService:AssetlinksService,
    private modalController: ModalController,
    private authservice:AuthService,
    private loadingService:LoadingService,
    private cloudFunctions:CloudfunctriggersService
  ) { }

  async ngOnInit() {
    this.paystackOptions = {
      amount: this.coupons[0].price || 1000, 
      email:this.authservice.giveCurrentUser().email,
      ref: `${Math.ceil(Math.random() * 10e10)}`,
      currency: 'ZAR',
    }
    this.buyButtonText = `Buy - R${(this.coupons[0].price)/100}`
  }

  async paymentInit() {
    this.linkClickThinking = true
  }

  async paymentCancel() {
    console.log('popup closed');
    this.linkClickThinking = false
  }

  async paymentDone(ref: TransActionRef){
    await this.loadingService.showOrContinueShowingLoading();
    this.cloudFunctions.verifyPayStackOnceOffTransaction(ref).then(async (verificationResult)=>{
        if(verificationResult.data.success){
            this.paymentResultSuccess.emit({
              coupon:this.coupons[0],
              response:verificationResult,
              ref
            });
            await this.loadingService.hideLoading();
        } else {
          this.paymentResultFailure.emit({
            coupon:this.coupons[0],
            response:verificationResult,
            ref
          });
        }
        this.linkClickThinking = false
        await this.loadingService.hideLoading();
    }).catch(async (err)=>{
      this.linkClickThinking = false
        console.log(err);
        await this.loadingService.hideLoading();
    })
  }

  log(e){
    console.log(e);
  }

  return(data = null) {
    this.modalController.dismiss(data);
  }

  onSwiper(params) {
    const [swiper] = params;
    
  }

  async openLink(couponListing:ForSaleCoupon) {
    if(!couponListing.productUrl){
      return
    }
    try {
      this.linkClickThinking = true
      this.linkClickThinking = false;
      Browser.open({
        url:couponListing.productUrl
      })
    } catch (error) {
      this.linkClickThinking = false
      console.log(error);
    }
  }

    
    onBeforeTransitionStart(params) {
    const [swiper, speed, internal] = params;
    console.log('beforeTransitionStart, speed: ' + speed);
    }
    
    
    slideNext(){
    this.swiper.swiperRef.slideNext(100);
    }
    
    slidePrev(){
    this.swiper.swiperRef.slidePrev(100);
    }

}
